
import axios from "axios"
import router from '../../router';

import { func } from '../../main';

const state = {
    UpdatesList: [],
    Loading:false
};


const getters = {
    GetUpdatesList(state: { UpdatesList: any; }) {
        return state.UpdatesList;
    }
};

const mutations = {

    SetUpdatesList(state: { UpdatesList: any; }, list: any) {
        state.UpdatesList = list;
    }

};

const actions = {
    GetUpdatesListFromServer(context: { commit: (arg0: string, arg1: any) => void; }) {
        axios.get("Account/ServerFiltering_GetUpdatesList", {
        })
            .then((data: any) => {
                context.commit("SetUpdatesList", data.data);
            });
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};
